export default "__VITE_ASSET__B5X8CkWe__"